module.exports = __webpack_public_path__ + "img/story039@2x.82d9736b.webp";